export const MAPBOX_DEFAULT_LAYER = 'mapbox://styles/mapbox/streets-v12'

export const MAPBOX_SATELLITE_LAYER =
   'mapbox://styles/mapbox/satellite-streets-v12'
